import styled from 'styled-components';

export const IconLogoHeader = styled.div`
  width: 3rem;
  height: 3rem;
  display: flex;
  align-items: center;
  justify-content: center;

  border: 1px solid ${(props) => props.backgroundColor};
  border-radius: 999999999px;
  background-color: ${(props) => props.backgroundColor};
`;

export const TableWrapper = styled.div`
  width: 100%;
  max-width: 100%;
  overflow-x: auto;
  box-sizing: border-box;
`;

export const StyledTable = styled.table`
  width: 100%;
  min-width: 800px;
  max-width: 100%;
  table-layout: auto;
  border-collapse: separate;
  border-spacing: 0;
  background: white;

  th, td {
    max-width: 250px;
    min-width: 100px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    vertical-align: middle;
  }

  th {
    background: #f6f9fc;
    position: sticky;
    top: 0;
    z-index: 2;
  }
`;
